/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import axios from "axios";
import { useLazyQuery } from "@apollo/client";
import GET_PAGES from "src/graphql/query/settings/getPages";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import NoRecordFound from "src/components/shared/molecules/NoRecordFound";
import CircularProgress from "@mui/material/CircularProgress";
import { FacebookFunc } from "src/utils/auth/Facebook";
import { enqueueSnackbar } from "notistack";
import UpperComponent from "./upperComponent";
import LowerComponent from "./lowerComponent";
import { User } from "./upperComponent/types";
import useStyle from "./Styles";

declare global {
  interface Window {
    FB: any;
  }
}

const Facebook: React.FC = () => {
  const { classes } = useStyle();
  const [pagesData, setPagesData] = useState<any[]>([]);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const [loggedInUserDetail, setloggedInUserDetail] = useState<User | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { mainSuperAdminId } = useActiveUserDetail();

  useEffect(() => {
    FacebookFunc.fbInt();
  }, []);

  useEffect(() => {
    const getLoginStatus = async () => {
      if (window.FB) {
        try {
          setIsLoading(true);
          window.FB.getLoginStatus(async function getStatus(response: any) {
            if (response.status === "connected") {
              const { accessToken } = response.authResponse;
              const user = await axios.get(
                `https://graph.facebook.com/me?access_token=${accessToken}&fields=id,name,email,picture.width(640).height(640)`,
              );
              setloggedInUserDetail(user.data);
            }
          }, true);
        } catch {
          enqueueSnackbar("Something went wrong. Try again.", {
            variant: "error",
          });
        } finally {
          setIsLoading(false);
        }
      }
    };
    getLoginStatus();
  }, [window.FB]);

  const [
    getPages,
    { loading: getPagesQueryLoading, data: getPagesQueryResult },
  ] = useLazyQuery(GET_PAGES, { fetchPolicy: "network-only" });

  useEffect(() => {
    getPages({
      variables: { mainSuperAdminId, source: "facebook", onlySelected: false },
    });
  }, [mainSuperAdminId]);

  useEffect(() => {
    if (getPagesQueryResult?.getAllPages?.result?.length) {
      const pages = getPagesQueryResult.getAllPages.result.map(
        (curr: any, index: number) => ({ order: index, ...curr }),
      );
      setPagesData([...pages]);
    } else if (getPagesQueryResult?.getAllPages?.success === 0) {
      enqueueSnackbar(getPagesQueryResult.getAllPages.error, {
        variant: "error",
      });
      setPagesData([]);
    } else {
      setPagesData([]);
    }
  }, [getPagesQueryResult]);

  const [, setErrorBoxHeight] = useState<number>(0);

  const handleScroll = () => {
    if (scrollRef.current) {
      const currentScroll = scrollRef.current.scrollTop;
      // Hysteresis: Collapse at 60px, only Expand back at < 10px for maximum stability
      if (currentScroll > 60) {
        setIsCollapsed(true);
      } else if (currentScroll < 10) {
        setIsCollapsed(false);
      }
    }
  };

  return (
    <Box className={classes.rootBox} ref={scrollRef} onScroll={handleScroll}>
      <Box className={classes.decorationBlob} />

      {isLoading || getPagesQueryLoading ? (
        <Box className={classes.loadingCircularProgressBox}>
          <CircularProgress sx={{ color: "#4D1277" }} />
        </Box>
      ) : (
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            // Guaranteed scroll room to prevent layout-driven scroll resets
            minHeight: "calc(100% + 200px)",
          }}
        >
          {/* Sticky hero / profile card */}
          <Box className={classes.stickyHeader}>
            <UpperComponent
              setPagesData={setPagesData}
              loggedInUserDetail={loggedInUserDetail}
              setloggedInUserDetail={setloggedInUserDetail}
              setErrorBoxHeight={setErrorBoxHeight}
              isCollapsed={isCollapsed}
            />
          </Box>

          {/* Pages list */}
          {!getPagesQueryLoading && pagesData.length > 0 && (
            <Box
              sx={{
                // mt: isCollapsed ? 26 : 3,
                mt: isCollapsed ? "100px" : "20px",
                transition: "margin-top 0.45s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <LowerComponent
                pagesData={pagesData}
                setPagesData={setPagesData}
              />
            </Box>
          )}

          {!getPagesQueryLoading && pagesData.length === 0 && (
            <Box mt={10} display="flex" justifyContent="center">
              <NoRecordFound />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Facebook;
